import { Component, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AlertController, LoadingController, NavController, NavParams } from 'ionic-angular';
import { ContentBlock } from '../../models/content-block';
import { Entry } from '../../models/entry';
import { Api } from '../../providers/api';
import { BrowseCategoryPage } from '../browse-category/browse-category';
import { GoogleMap } from '../../components/google-map';
import { GoogleMapsService } from '../../providers/google-maps';
import { BookmarkService } from '../../providers/bookmark-service';
import { LaunchNavigator } from '@ionic-native/launch-navigator';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics';

@Component({
  selector: 'page-bookmark',
  templateUrl: 'bookmark.html'
})
export class BookmarkPage {

    @ViewChild('map') public map: GoogleMap;

    public contentBlocks: ContentBlock[];
    public entry: Entry;
    public sections: Entry[];

    public isBookmarked: boolean = false;
    public location: string;
    public latLng: google.maps.LatLng;

    constructor(
        public alertCtrl: AlertController,
        public analytics: FirebaseAnalytics,
        public api: Api,
        public bookmarks: BookmarkService,
        public domSanitizer: DomSanitizer,
        public googleMaps: GoogleMapsService,
        public launchNavigator: LaunchNavigator,
        public loadingCtrl: LoadingController,
        public navCtrl: NavController,
        public navParams: NavParams,
    ) {
        this.contentBlocks = this.navParams.get('content_blocks');
        this.entry = this.navParams.get('entry');
        this.sections = Entry.sortByTitle(this.navParams.get('entries'));

        for (let block of this.contentBlocks) {
            if (block.location) {
                this.location = block.location;
                break;
            }
        }
    }

    public ionViewDidEnter() {
        this.analytics.setCurrentScreen('Entry');
        this.analytics.logEvent('entry_view', {
            entry_id: this.entry.id,
            entry_title: this.entry.title,
        });
    }

    public async ngAfterViewInit() {
        this.isBookmarked = await this.bookmarks.has(this.entry.id);

        if (this.location) {
            this.latLng = await this.googleMaps.geocodeToLatLng(this.location);
            this.map.setCenter(this.latLng);
            this.map.addMarker({
                position: this.latLng
            });
        }
    }

    public getParents() {
        let parents = [];

        for (let parent of this.entry.parents) {
            parents.push(parent.title);
        }

        return parents.length > 0 ? parents.reverse() : null;
    }

    public getAbsoluteImageUrl(url: string): URL {
        if (url.charAt(0) == '/') {
            let result = this.api.getEndpoint();
            result.pathname = url;
            return result;
        } else {
            return new URL(url);
        }
    }

    public getDirections() {
        this.launchNavigator.navigate(this.latLng.toUrlValue());
    }

    public showEntry(entry: Entry) {
        let loading = this.loadingCtrl.create();
        loading.present();

        this.api.getEntryById(entry.id).finally(() => {
            loading.dismiss();
        }).subscribe(result => {
            let contentBlocks = result.content_blocks;
            let entries = result.entries;

            if (contentBlocks.length <= 0) {
                this.navCtrl.push(BrowseCategoryPage, {
                    entries: entries,
                    entry: entry
                });
            } else {
                this.navCtrl.push(BookmarkPage, {
                    content_blocks: contentBlocks,
                    entries: entries,
                    entry: entry
                });
            }
        }, () => {
            let alert = this.alertCtrl.create({
                title: 'Error',
                message: 'An error occured while trying to fetch "' + entry.title + '"',
                buttons: [{
                    text: 'OK'
                }]
            });

            alert.present();
        });
    }

    public async toggleBookmark(): Promise<boolean> {
        if (this.isBookmarked) await this.bookmarks.remove(this.entry);
        else await this.bookmarks.add(this.entry);

        this.isBookmarked = await this.bookmarks.has(this.entry.id);

        return this.isBookmarked;
    }

}



// WEBPACK FOOTER //
// ./src/pages/bookmark/bookmark.ts